import { useEffect, useState } from "react";
import { getConsent, setConsent } from "../lib/consent";
import {
  initGoogleConsentDefaults,
  loadGoogleAnalytics,
  updateGoogleConsent,
} from "../lib/loadAnalytics";
import CookiePreferencesModal from "./CookiePreferencesModal";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    initGoogleConsentDefaults();

    const consent = getConsent();

    if (!consent) {
      setVisible(true);
      return;
    }

    updateGoogleConsent(consent);

    if (consent.analytics || consent.marketing) {
      loadGoogleAnalytics();
    }
  }, []);

  useEffect(() => {
    const handler = () => setIsModalOpen(true);

    window.addEventListener("open-cookie-preferences", handler);

    return () => {
      window.removeEventListener("open-cookie-preferences", handler);
    };
  }, []);

  const acceptAll = () => {
    const consent = {
      essential: true,
      analytics: true,
      marketing: true,
    };

    setConsent(consent);
    loadGoogleAnalytics();
    updateGoogleConsent(consent);
    setVisible(false);
  };

  const refuseAll = () => {
    const consent = {
      essential: true,
      analytics: false,
      marketing: false,
    };

    setConsent(consent);
    updateGoogleConsent(consent);
    setVisible(false);
  };

  const openPreferences = () => {
    setIsModalOpen(true);
  };

  const closePreferences = () => {
    setIsModalOpen(false);

    const consent = getConsent();
    if (consent) {
      setVisible(false);
    }
  };

  return (
    <>
      {visible && (
        <div className="fixed bottom-4 left-4 right-4 z-50 rounded-2xl border border-[#E6E1D6] bg-[#FFFCF8] p-5 shadow-xl md:left-6 md:right-6">
          <h3 className="flex items-center gap-2 text-lg font-semibold text-[#2A2A2A]">
            🍪 Cookies
          </h3>

          <p className="mt-2 text-sm text-[#5F5F5F]">
            Nous utilisons des cookies essentiels et, avec votre accord, des cookies
            de mesure d’audience et marketing.
          </p>

          <div className="mt-4 flex flex-wrap gap-2">
            <button
              onClick={acceptAll}
              className="rounded-xl bg-[#2A2A2A] px-4 py-2 text-sm font-medium text-white hover:opacity-90"
            >
              Accepter
            </button>

            <button
              onClick={refuseAll}
              className="rounded-xl border border-[#D6CFC2] px-4 py-2 text-sm font-medium text-[#2A2A2A] hover:bg-[#F5F1EA]"
            >
              Refuser
            </button>

            <button
              onClick={openPreferences}
              className="rounded-xl border border-[#2A2A2A] px-4 py-2 text-sm font-medium text-[#2A2A2A] hover:bg-[#F0ECE5]"
            >
              Personnaliser
            </button>
          </div>
        </div>
      )}

      <CookiePreferencesModal
        isOpen={isModalOpen}
        onClose={closePreferences}
      />
    </>
  );
}